export {
  default as tv,
  ReactComponent as Tv,
} from '@assets/icons/features-and-amenities/tv.svg'    
